import { Component, OnInit, Directive, ElementRef, Host } from '@angular/core';

@Component({
  selector: 'ins-modal-footer2',
  templateUrl: './modal-footer2.component.html',
  styleUrls: ['./modal-footer2.component.scss'],
})
export class ModalFooter2Component {}

@Directive({
  selector: '[space-between]',
})
export class FooterStyleSpaceBetween {
  constructor(private _elementRef: ElementRef) {
    _elementRef.nativeElement.style.justifyContent = 'space-between';
  }
}
